const { createBundleTiles } = require('../../shop/tiles/product-tile-factory');
const { map } = require('lodash');

class OfferGroupTileListController {
    constructor(settings, analyticsService, offerGroupService) {
        this.settings = settings;
        this.analyticsService = analyticsService;
        this.offerGroupService = offerGroupService;
    }

    $onInit() {
        this.sortOptions = this.offerGroupService.getSortOptions();
    }

    title() {
        const description = this.offerGroupService.selectedGroup.Description;

        return this.offerGroupService.selectedGroupTotalCount != null
            ? `${description} (${this.offerGroupService.selectedGroupTotalCount})`
            : description;
    }

    createTiles(products) {
        return {
            items: createBundleTiles(products.items),
            totalRecordCount: products.totalRecordCount,
        };
    }

    getTiles(pageSize, pageNumber, sortType = 'Name') {
        return this.offerGroupService.selectOfferGroup(this.offerGroupId)
            .then(() => this.offerGroupService.getProducts({ pageSize, pageNumber, sortType }))
            .then(products => this.createTiles(products));
    }

    createAnalyticsData(contentData) {
        return {
            pageNumber: contentData.pageNumber,
            currentCategory: this.offerGroupService.selectedGroup,
            products: map(contentData.items, item => ({ Name: item.data.product.Name, Products: [item.data.product] })),
            inspirationCards: { Cards: contentData.inspirationCards },
            totalRecordCount: this.offerGroupService.selectedGroupTotalCount,
            filters: contentData.filters,
            sortType: contentData.sortType ? contentData.sortType.Value : '',
            sortOptions: this.sortOptions,
        };
    }

    pushContentDataToAnalytics(contentData) {
        this.analyticsService.push({
            data: this.createAnalyticsData(contentData),
            type: this.analyticsService.mapperTypes.shop.productCategory,
        });
    }
}

OfferGroupTileListController.$inject = ['Settings', 'AnalyticsService', 'OfferGroupService'];

const offerGroupTileListComponentDefinition = {
    bindings: {
        offerGroupId: '<?',
        pageNumber: '<',
        sortBy: '<',
    },
    controller: OfferGroupTileListController,
    template: `
        <wow-tile-list
            list-title="$ctrl.title()"
            page-number="$ctrl.pageNumber"
            sort-by="$ctrl.sortBy"
            sort-options="::$ctrl.sortOptions"
            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType)"
            push-content-to-analytics="$ctrl.pushContentDataToAnalytics(contentData)">
        </wow-tile-list>
    `,
};

module.exports = {
    OfferGroupTileListController,
    offerGroupTileListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/offergroup/offergroup-tile-list.component.js